import { assets } from "@/config/site";
import { Section } from "./Section";
import { Reveal, ImageReveal, Parallax } from "./Reveal";

export const About = () => (
    <Section id="about" index="10" label="The Brand" title="One destination. Every detail.">
        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-8">
            <Reveal className="lg:col-span-5" delay={0.1}>
                <p className="max-w-[60ch] text-base leading-relaxed text-rz-smoke sm:text-lg">
                    Revautoz is a premium automotive destination in Goa for detailing, protection,
                    restoration and bespoke customization. From paint correction and paint protection
                    film to full custom builds and bodyshop work, every vehicle is handled with the
                    same standard of precision.
                </p>
                <p className="mt-6 max-w-[60ch] text-base leading-relaxed text-rz-smoke">
                    One studio in Mapusa, North Goa — built for people who notice the difference
                    between clean and corrected, covered and protected, modified and crafted. Whether
                    it's car detailing in Mapusa, PPF for a new car, ceramic coating in North Goa or
                    a full bodyshop repair, the work follows the same process and the same standard.
                </p>
                <div className="mt-10 flex items-center gap-4">
                    <span className="h-px w-16 bg-rz-red" />
                    <span className="font-display text-[11px] uppercase tracking-[0.22em] text-rz-smoke">
                        Revautoz — by Apex Automotive
                    </span>
                </div>
            </Reveal>
            <div className="lg:col-span-6 lg:col-start-7">
                <ImageReveal className="relative" delay={0.15}>
                    <div className="absolute -left-3 -top-3 h-full w-full border border-rz-red/60" aria-hidden="true" />
                    <Parallax amount={28}>
                        <img
                            src={assets.facility}
                            alt="The Revautoz studio storefront in Colvale, Mapusa — Ride. Redefined. signage above the entrance"
                            loading="lazy"
                            decoding="async"
                            className="relative aspect-[4/5] w-full scale-[1.08] object-cover sm:aspect-[5/4] lg:aspect-[4/5]"
                        />
                    </Parallax>
                    <p className="mt-4 font-display text-[11px] uppercase tracking-[0.2em] text-rz-smoke">
                        The studio — Colvale, Mapusa, Goa
                    </p>
                </ImageReveal>
            </div>
        </div>
    </Section>
);
